import React from "react";
import { Outlet } from "react-router-dom";
import { Footer, Header } from "../Components";

const Layout = () => {
  return (
    <div>
      <Header />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
